import './style.scss';

document.addEventListener('DOMContentLoaded', function () {
    const root = document.querySelector('.booom-keuzehulp');
    if (!root || typeof KeuzehulpData === 'undefined') return;

    const { flowchart, diensten } = KeuzehulpData;
    const nodes   = flowchart.nodes || {};
    const mapping = flowchart.gf_mapping?.dienst_to_checkbox_value || {};

    const wizardEl    = root.querySelector('#keuzehulp-wizard');
    const resultsEl   = root.querySelector('#keuzehulp-results');
    const cardsGridEl = root.querySelector('#keuzehulp-cards-grid');
    const emptyEl     = root.querySelector('#keuzehulp-empty');
    const offerteBtn  = root.querySelector('#keuzehulp-offerte-trigger');

    const modalOverlay = document.getElementById('keuzehulp-modal-overlay');
    const modalClose   = document.getElementById('keuzehulp-modal-close');

    let history          = [];
    let selectedDiensten = new Set();

    // ── Wizard ───────────────────────────────────────────────────────────────

    function showQuestion(nodeId) {
        const node = nodes[nodeId];
        if (!node) return;

        history.push(nodeId);

        if (node.type === 'result') {
            transitionToResults(node);
            return;
        }

        wizardEl.classList.remove('hidden');
        resultsEl.classList.add('hidden');
        emptyEl.classList.add('hidden');

        const depth      = history.length - 1;
        const totalDepth = calcMaxDepth(flowchart.start);

        wizardEl.innerHTML = `
            ${buildProgressDots(depth, totalDepth)}
            <div class="wizard-question mt-6">
                <h2 class="text-2xl md:text-3xl font-bold text-primary mb-6">
                    ${escHtml(node.label || '')}
                </h2>
                <div class="wizard-answers flex flex-col gap-3 max-w-xl">
                    ${(node.answers || []).map(a => `
                        <button
                            type="button"
                            class="wizard-answer-btn text-left bg-surface border-2 border-border hover:border-primary px-5 py-4 rounded-corner-md font-bold text-primary shadow-3xl transition-all duration-150 hover:translate-x-1"
                            data-next="${escAttr(a.next || '')}">
                            ${escHtml(a.label)}
                        </button>
                    `).join('')}
                </div>
            </div>
            ${history.length > 1
                ? `<button type="button" class="wizard-back mt-6 text-muted underline text-sm hover:text-primary transition-colors">← Vorige vraag</button>`
                : ''}
        `;

        wizardEl.querySelector('.wizard-back')?.addEventListener('click', goBack);
        wizardEl.querySelectorAll('.wizard-answer-btn').forEach(btn => {
            btn.addEventListener('click', () => {
                const next = btn.dataset.next;
                if (next) showQuestion(next);
            });
        });
    }

    function goBack() {
        history.pop();
        const prev = history.pop();
        prev ? showQuestion(prev) : restart();
    }

    function restart() {
        history = [];
        selectedDiensten.clear();
        wizardEl.classList.remove('hidden');
        resultsEl.classList.add('hidden');
        emptyEl.classList.add('hidden');
        showQuestion(flowchart.start);
    }

    // ── Results ──────────────────────────────────────────────────────────────

    function transitionToResults(resultNode) {
        const ids = (resultNode.diensten || []).map(Number).filter(id => diensten[id]);

        wizardEl.classList.add('hidden');

        if (ids.length === 0) {
            resultsEl.classList.add('hidden');
            emptyEl.classList.remove('hidden');
            return;
        }

        resultsEl.classList.remove('hidden');
        emptyEl.classList.add('hidden');
        selectedDiensten = new Set(ids);

        cardsGridEl.innerHTML = ids.map((id, i) => buildDienstCard(id, i)).join('');

        cardsGridEl.querySelectorAll('.keuzehulp-card').forEach(card => {
            card.addEventListener('click', () => toggleDienst(card));
        });

        syncOfferteButton();
    }

    function toggleDienst(card) {
        const id = Number(card.dataset.dienstId);
        if (selectedDiensten.has(id)) {
            selectedDiensten.delete(id);
            card.classList.remove('is-selected');
        } else {
            selectedDiensten.add(id);
            card.classList.add('is-selected');
        }
        syncOfferteButton();
    }

    function syncOfferteButton() {
        offerteBtn?.classList.toggle('hidden', selectedDiensten.size === 0);
    }

    // ── Card — matches dienst-card template-part structure ───────────────────

    function buildDienstCard(id, index) {
        const d = diensten[id];
        if (!d) return '';

        const delay = index * 50;
        const thumb = d.thumbnail
            ? `<img src="${escAttr(d.thumbnail)}" alt="${escAttr(d.title)}"
                    class="w-full h-full object-cover will-change-transform transition-transform duration-300 group-hover:scale-[1.075]">`
            : `<div class="w-full h-full bg-border-dark"></div>`;

        return `
            <article
                class="keuzehulp-card is-selected relative flex flex-col cursor-pointer"
                data-dienst-id="${id}"
                data-aos="fade-up"
                data-aos-delay="${delay}">

                <!-- Selection indicator badge -->
                <span class="kh-selected-badge absolute top-2 left-5 z-20 bg-contrast text-surface text-[13px] font-bold px-[10px] py-[3px] rounded-[5px] whitespace-nowrap pointer-events-none transition-opacity duration-150">
                    ✓ Geselecteerd
                </span>

                <div class="group flex flex-col flex-1 bg-border hover:bg-muted/[0.175] hover:ring-1 hover:ring-primary/30 rounded-corner-sm mt-[100px] transition-all duration-200">

                    <!-- Image -->
                    <div class="relative flex-shrink-0">
                        <div class="-mt-[100px] mx-3 aspect-[3/2.5] sm:aspect-square overflow-hidden rounded-corner-sm group-hover:shadow-md group-hover:shadow-black/[0.075]">
                            ${thumb}
                        </div>
                        <!-- Arrow button (links through to dienst page) -->
                        <div class="absolute bottom-0 right-7 translate-y-1/2 z-10">
                            <a href="${escAttr(d.permalink)}" target="_blank"
                               class="flex-shrink-0 w-10 h-10 rounded-full bg-secondary flex items-center justify-center text-primary transition-colors duration-200 group-hover:bg-primary group-hover:text-surface"
                               aria-label="Meer info over ${escAttr(d.title)}"
                               onclick="event.stopPropagation()">
                                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
                                    <path d="M5 12h14M12 5l7 7-7 7"/>
                                </svg>
                            </a>
                        </div>
                    </div>

                    <!-- Content -->
                    <div class="flex flex-col flex-1 gap-2 px-5 pt-6 pb-5">
                        <p class="font-bold text-primary group-hover:underline !m-0">${escHtml(d.title)}</p>
                        ${d.excerpt ? `<p class="text-primary line-clamp-3 !m-0 group-hover:opacity-70 transition-opacity duration-200">${escHtml(d.excerpt)}</p>` : ''}
                    </div>
                </div>
            </article>
        `;
    }

    // ── Progress dots ────────────────────────────────────────────────────────

    function buildProgressDots(current, total) {
        if (total <= 1) return '';
        const dots = Array.from({ length: total }, (_, i) =>
            `<span class="inline-block w-2.5 h-2.5 rounded-full transition-colors duration-200 ${i <= current ? 'bg-primary' : 'bg-border'}"></span>`
        ).join('');
        return `<div class="flex gap-2 mb-4">${dots}</div>`;
    }

    function calcMaxDepth(startId, visited = new Set()) {
        if (visited.has(startId)) return 0;
        visited.add(startId);
        const node = nodes[startId];
        if (!node || node.type === 'result') return 0;
        let max = 0;
        for (const a of (node.answers || [])) {
            if (a.next) max = Math.max(max, 1 + calcMaxDepth(a.next, new Set(visited)));
        }
        return max;
    }

    // ── Custom modal ─────────────────────────────────────────────────────────

    function openModal() {
        modalOverlay.classList.remove('hidden');
        modalOverlay.classList.add('flex');
        document.body.style.overflow = 'hidden';
        preFillGravityForm();
    }

    function closeModal() {
        modalOverlay.classList.add('hidden');
        modalOverlay.classList.remove('flex');
        document.body.style.overflow = '';
    }

    offerteBtn?.addEventListener('click', openModal);
    modalClose?.addEventListener('click', closeModal);

    // Close on overlay backdrop click
    modalOverlay?.addEventListener('click', e => {
        if (e.target === modalOverlay) closeModal();
    });

    // Close on Esc
    document.addEventListener('keydown', e => {
        if (e.key === 'Escape' && !modalOverlay.classList.contains('hidden')) closeModal();
    });

    // ── GF pre-population ────────────────────────────────────────────────────

    function preFillGravityForm() {
        const formId = flowchart.gf_mapping?.gf_form_id || 4;
        const formEl = document.getElementById('gform_' + formId);
        if (!formEl) return;
        tickCheckboxes(formEl);
    }

    function tickCheckboxes(formEl) {
        // Uncheck all first for a clean slate
        formEl.querySelectorAll('input[type="checkbox"]').forEach(cb => { cb.checked = false; });

        selectedDiensten.forEach(id => {
            const cbValue = mapping[id];
            if (!cbValue) return;
            formEl.querySelectorAll('input[type="checkbox"]').forEach(cb => {
                if (cb.value === cbValue) {
                    cb.checked = true;
                    cb.dispatchEvent(new Event('change', { bubbles: true }));
                }
            });
        });
    }

    // GF renders the form after AJAX — re-tick when it re-renders inside the modal
    if (typeof jQuery !== 'undefined') {
        jQuery(document).on('gform_post_render', function (e, formId) {
            if (formId == (flowchart.gf_mapping?.gf_form_id || 4)) {
                const formEl = document.getElementById('gform_' + formId);
                if (formEl) tickCheckboxes(formEl);
            }
        });
    }

    // ── Restart ──────────────────────────────────────────────────────────────

    root.querySelector('#keuzehulp-restart')?.addEventListener('click', restart);
    root.querySelector('#keuzehulp-restart-empty')?.addEventListener('click', restart);

    // ── Helpers ──────────────────────────────────────────────────────────────

    function escHtml(str) {
        return String(str)
            .replace(/&/g, '&amp;').replace(/</g, '&lt;')
            .replace(/>/g, '&gt;').replace(/"/g, '&quot;');
    }
    function escAttr(str) {
        return String(str).replace(/"/g, '&quot;').replace(/'/g, '&#39;');
    }

    // ── Boot ─────────────────────────────────────────────────────────────────

    showQuestion(flowchart.start);
});
